export default [
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/menu/product/product.vue'),
    meta: {
      pageTitle: 'مدیریت کالاها',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/producttariff',
    name: 'producttariff',
    component: () => import('@/views/menu/product/producttariff.vue'),
    meta: {
      pageTitle: 'مدیریت تعرفه ها',
      action: 'show',
      resource: 'ProductTariffManager',
    },
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/menu/product/brand.vue'),
    meta: {
      pageTitle: 'مدیریت برندها',
      action: 'show',
      resource: 'BrandManager',
    },
  },
  {
    path: '/productunit',
    name: 'productunit',
    component: () => import('@/views/menu/product/productunit.vue'),
    meta: {
      pageTitle: 'مدیریت واحدها',
      action: 'show',
      resource: 'ProductUnitManager',
    },
  },
  {
    path: '/purchasetype',
    name: 'purchasetype',
    component: () => import('@/views/menu/product/purchasetype.vue'),
    meta: {
      pageTitle: 'مدیریت واحدها',
      action: 'show',
      resource: 'PurchaseTypeManager',
    },
  },
  {
    path: '/productcategory',
    name: 'productcategory',
    component: () => import('@/views/menu/product/productcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی ها',
      action: 'show',
      resource: 'ProductCategoryManager',
    },
  },
]
